module.exports = __webpack_public_path__ + "assets/media/recordVideoTooltipPlus.46859039.png";